import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';

import { BuilderChatButtonContainer } from '../BuilderChatButton';

interface IMessageButtonContainerProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = props => {
  return <BuilderChatButtonContainer {...props} />;
};
